import { inject, Injectable, signal } from '@angular/core';
import { CookieService } from 'ngx-unificator/services';
import { StaticContentService } from './static-content.service';
import { filter, first, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

export const NATIVE_APP_COOKIE = 'isNativeApp';
@Injectable({
  providedIn: 'root',
})
export class InstallAppService {
  private _cookie = inject(CookieService);
  private _static = inject(StaticContentService);

  public nativeAppValueResolved$ = new BehaviorSubject<boolean>(false);
  /**
   * Variables for show/hide install app block logic (register block, notification message, banner after deposit)
   * @private
   */
  public showInstallAppRegisterBlock = signal<boolean>(null);
  public showInstallAppNotificationMessage= signal<boolean>(null);
  public showInstallAppAfterDepositBanner= signal<boolean>(null);
  public canShowAfterDepositBanner= signal<boolean>(null);
  public isEnableNativeApp= signal<boolean>(this._cookie.check(NATIVE_APP_COOKIE));

  /**
   * Cookie name variables
   */
  private _registerCookieName: string = '--register-install-app';
  private _notificationCookieName: string = '--notification-install-app';
  private _depositCookieName: string = '--deposit-install-app';

  private _resolvedVariables: boolean;

  checkIsNativeAppEnabled() {
    this._static
      .item({ slug: 'enabled-native-app' })
      .pipe(
        filter(data => data),
        first(),
        tap(data => {
          // isEnableNativeApp false, meaning that everything related to native app would be hidden
          if (data?.[0]?.Content) {
            this.isEnableNativeApp.set(!this._cookie.check(NATIVE_APP_COOKIE));
          } else {
            this.isEnableNativeApp.set(false);
          }
          this.nativeAppValueResolved$.next(this.isEnableNativeApp());
        }),
      )
      .subscribe();
  }

  /**
   * Resolve show variables (check cookie)
   * @private
   */
  public resolveShowVariables() {
    if (!this._resolvedVariables) {
      this.showInstallAppRegisterBlock.set(!Boolean(this._cookie.get(this._registerCookieName)));
      this.showInstallAppNotificationMessage.set(!Boolean(this._cookie.get(this._notificationCookieName)));
      this.canShowAfterDepositBanner.set(!Boolean(this._cookie.get(this._depositCookieName)));
      this._resolvedVariables = true;
    }
  }

  public closeRegisterBlock() {
    this.showInstallAppRegisterBlock.set(false);
    this._cookie.set(this._registerCookieName, '1');
  }

  public closeNotificationBlock() {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1);
    this.showInstallAppNotificationMessage.set(false);
    this._cookie.set(this._notificationCookieName, '1', { expires: expirationDate });
  }

  public closeDepositBlock() {
    this.showInstallAppAfterDepositBanner.set(false);
    this._cookie.set(this._depositCookieName, '1');
  }
}
